import { HttpClient } from "@angular/common/http";
import { Component, OnInit, OnDestroy, ViewChildren, QueryList, ViewChild, AfterViewInit } from "@angular/core";
import { v4 as uuid4 } from "uuid";
import { DataTableDirective } from 'angular-datatables';
import { skip } from "rxjs/operators";

import { environment } from '../../../../../../environments/environment';
import { BusOtherKpFilterService } from '../../../services/bus-other-kp-filter.service';
import { KamListFilter } from '../../../models/kam-list-filter';
import { OtherKpFilter } from '../../../models/other-kp-filter';
import { NomenclatureListFilter } from '../../../models/nomenclature-list-filter';
import { OtherKpDetailService } from '../../../services/other-kp-detail.service';
import { Nomenclature } from '../../../models/nomenclature';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;
const MODULE_PATH = "TakomaClient.app.modules.other-kp.component.other-kp-main"
const controller = '/otherKp';
declare var $: any;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-other-kp-main-modal-nomenclature',
  templateUrl: './other-kp-main-modal-nomenclature.component.html',
  styleUrls: ['./other-kp-main-modal-nomenclature.component.sass']
})
export class OtherKpNomenclaturesComponent implements OnInit, OnDestroy, AfterViewInit {

  private subs: any[] = [];

  @ViewChild(DataTableDirective) datatableElement: DataTableDirective;
  @ViewChildren('nameInput') nameInputModel: QueryList<any>;

  checkedNomenclatureMember: number[];

  dt: DataTables.Api;
  modelNomenclatureFilter: NomenclatureListFilter = new NomenclatureListFilter();
  modelAuctionFilter: OtherKpFilter = new OtherKpFilter();
  dtOptionsNomenclatureMembers: DataTables.Settings = {};
  dataSetNomenclatures: any;

  constructor(private http: HttpClient, private service: OtherKpDetailService, private bus: BusOtherKpFilterService, private loggingService: LoggingService) {
    this.checkedNomenclatureMember = [];
  }

  ngOnInit() {
    $('#modalOtherKpNomenclature').off('show.bs.modal shown.bs.modal hidden.bs.modal')
      .on('show.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1030);
        $('#modalOtherKpDetail').css('z-index', 1040);
      })
      .on('shown.bs.modal', function () {
        $('#modalOtherKpNomenclature').css('z-index', 1070);
        $('.modal-backdrop:last').css('z-index', 1065);
        setTimeout(() => that.selectNomenclature(that.service.preSelectedNomenclature || []), 400);
      })
      .on('hidden.bs.modal', function () {
        $('#modalAuctionDetail').css('z-index', 1041);
        $('#modalOtherKpDetail').css('z-index', 1060);
      });

    this.subs.push(this.service.preSelectedNomenclatures$.subscribe(key => {
      this.selectNomenclature(this.service.preSelectedNomenclature)
    }));

    this.subs.push(
      this.bus.currentClearModalFilter$
        .pipe(skip(1))  // При инициализации фильтр уже очищен
        .subscribe(key => {
          if (key === 'nomenclatureMember') {
            this.nameInputModel.forEach(function (item) {
              item.nativeElement.checked = false;
            });
            this.checkedNomenclatureMember = [];
            this.onSet();
          }
        })
    );

    this.subs.push(this.bus.currentClearSearchModalFields$.subscribe(key => {
      if (key === 'nomenclatureMemberName') {
        console.log(key);
        this.modelNomenclatureFilter.name = null;
        this.onFieldChange();
      }
    }));

    const that = this;
    this.dtOptionsNomenclatureMembers = {
      pagingType: 'full_numbers',
      pageLength: 100,
      serverSide: true,
      processing: true,
      autoWidth: false,
      dom: 'tip',
      order: [1],
      language: {
        emptyTable: 'Нет данных',
        info: 'Отображено с _START_ по _END_ из _TOTAL_ записей',
        infoEmpty: 'Отображено с 0 по 0 из 0 записей',
        infoFiltered: '(отфильтровано из _MAX_ записей)',
        infoPostFix: '',
        thousands: ',',
        lengthMenu: 'Показывать по _MENU_ записей',
        loadingRecords: 'Загрузка ...',
        processing: 'Обработка ...',
        search: 'Поиск:',
        zeroRecords: '',
        paginate: {
          first: 'Первая',
          last: 'Последняя',
          next: 'След.',
          previous: 'Пред.'
        },
        aria: {
          sortAscending: ': activate to sort column ascending',
          sortDescending: ': activate to sort column descending'
        }
      },
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.search = this.modelNomenclatureFilter.name;

        that.http.post<DataTablesResponse>(`${apiServer + controller}/nomenclaturesList`, dataTablesParameters, {})
          .subscribe(resp => {
            that.dataSetNomenclatures = resp.data;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: [
        { orderable: false },
        { data: 'distrName', name: 'distrName' },
      ]
    };

  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }

  onFieldChange() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpNomenclaturesComponent.onFieldChange', null, 'Field change started');
      
      let that = this
      this.dt.ajax.reload();
      setTimeout(function () {
        that.reSelectCheckedNomenclature()
      }, 1000);
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpNomenclaturesComponent.onFieldChange', null, 'Field change completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpNomenclaturesComponent.onFieldChange', _error, null, 'Field change failed');
      throw _error;
    }
  }

  reSelectCheckedNomenclature() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpNomenclaturesComponent.reSelectCheckedNomenclature', null, 'Reselect checked nomenclature started');
      
      let that = this
      this.checkedNomenclatureMember.forEach(el => {
        const element = document.querySelector(`input[value="${that.dataSetNomenclatures.find(data => data.nomenclatureId == el)?.name}"]`) as HTMLInputElement;
        if (element != null) {
          element.checked = true;
        }
      })
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpNomenclaturesComponent.reSelectCheckedNomenclature', null, 'Reselect checked nomenclature completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpNomenclaturesComponent.reSelectCheckedNomenclature', _error, null, 'Reselect checked nomenclature failed');
      throw _error;
    }
  }

  selectNomenclature(nomenclatureList: Array<Nomenclature>): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.OtherKpNomenclaturesComponent.selectNomenclature`;
    const inputParams = { "nomenclatureList": nomenclatureList };
    const description = "Выбор номенклатуры";

    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);

      this.checkedNomenclatureMember = []

      this.nameInputModel.forEach(item => {
        item.nativeElement.checked = false;
      });

      nomenclatureList.forEach(nomenclature => {
        this.checkedNomenclatureMember.push(nomenclature.goodId);

        const element = document.querySelector(`input[value="${nomenclature.name}"]`) as HTMLInputElement;

        if (element != null) {
          element.checked = true;
        }
      });
      
      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSelectedRowMember(event, value) {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSelectedRowMember', null, 'Row selection started');
      
      if (event.target.checked) {
        this.checkedNomenclatureMember.push(value);
      } else {
        for (let i = 0; i < this.checkedNomenclatureMember.length; i++) {
          if (this.checkedNomenclatureMember[i] === value) {
            this.checkedNomenclatureMember.splice(i, 1);
          }
        }
      }

      this.loggingService.logFinish(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSelectedRowMember', null, 'Row selection completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSelectedRowMember', _error, null, 'Row selection failed');
      throw _error;
    }
  }

  onSelectAllRowsCheckboxChange(selectAllRows: boolean): void {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.OtherKpNomenclaturesComponent.onSelectAllRowsCheckboxChange`;
    const inputParams = { "selectAllRows": selectAllRows };
    const description = "[EventHandler] Обработка изменения выбора всех строк номенлкатуры";

    try {
      this.loggingService.logStart(xid, qualName, inputParams, description);

      this.nameInputModel.forEach(row => {
        let nomenclatureID = Number(row.nativeElement.dataset.nomenclatureId);
        let selectedNomenclatureIndex = this.checkedNomenclatureMember.indexOf(nomenclatureID);

        if (selectAllRows && selectedNomenclatureIndex === -1) {  // Впервые устанавливается выбор наименования номенклатуры
          row.nativeElement.checked = true;

          this.checkedNomenclatureMember.push(nomenclatureID);
        } else if (!selectAllRows && selectedNomenclatureIndex !== -1) {  // Впервые снимается выбор наименования номенклатуры
          row.nativeElement.checked = false;

          this.checkedNomenclatureMember.splice(selectedNomenclatureIndex, 1);
        } else {
          // Пропуск наименования номенклатуры, так как её выбор повторно устанавливается или снимается
        }
      });

      this.loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this.loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  onSet() {
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSet', null, 'Set nomenclature started');
      
      this.service.changeNomenclature(this.checkedNomenclatureMember);
      
      this.loggingService.logFinish(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSet', null, 'Set nomenclature completed');
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.OtherKpNomenclaturesComponent.onSet', _error, null, 'Set nomenclature failed');
      throw _error;
    }
  }

  ngAfterViewInit(): void {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      this.dt = dtInstance;
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/other-kp/component/other-kp-main/other-kp-main-modal-nomenclature/other-kp-main-modal-nomenclature.component.ts